
export default function Testimonials() {
  const testimonials = [
    {
      name: '田中 美智子',
      location: '岡山市北区',
      project: 'キッチンリフォーム',
      rating: 5,
      comment: 'キッチンのリフォームをお願いしました。提案から施工まで丁寧で、想像以上の仕上がりに大満足です。岡山市でリフォームを考えている方にぜひおすすめしたいです。',
      image: 'https://public.readdy.ai/ai/img_res/f489741403f62c98a6163da87a178c83.jpg'
    },
    {
      name: '佐藤 健一',
      location: '倉敷市',
      project: '店舗改装工事',
      rating: 5,
      comment: '飲食店の改装をお願いしました。予算内で理想的な店舗に仕上げていただき、お客様からも好評です。倉敷市での店舗工事なら間違いなくおすすめです。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20restaurant%20owner%20in%20his%2040s%2C%20satisfied%20businessman%2C%20confident%20smile%2C%20standing%20in%20modern%20restaurant%20interior%2C%20successful%20entrepreneur%2C%20portrait%20style&width=300&height=300&seq=customer2&orientation=squarish'
    },
    {
      name: '山田 由美',
      location: '岡山市南区',
      project: 'バスルームリフォーム',
      rating: 5,
      comment: '古いお風呂を最新のユニットバスにリフォームしていただきました。工期も予定通りで、毎日のお風呂タイムが楽しみになりました。',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20woman%20in%20her%2040s%2C%20satisfied%20homeowner%2C%20gentle%20smile%2C%20relaxed%20appearance%2C%20comfortable%20home%20setting%2C%20pleased%20customer%2C%20portrait%20style&width=300&height=300&seq=customer3&orientation=squarish'
    },
    {
      name: '鈴木 正雄',
      location: '倉敷市児島',
      project: '外壁修繕工事',
      rating: 5,
      comment: '雨漏りの修繕工事をお願いしました。原因をしっかり調査して根本的な解決をしていただき、安心して住めるようになりました。アフターサービスも充実しています。',
      image: 'https://readdy.ai/api/search-image?query=Reliable%20Japanese%20man%20in%20his%2060s%2C%20satisfied%20homeowner%2C%20trustworthy%20appearance%2C%20standing%20outside%20well-maintained%20house%2C%20experienced%20customer%2C%20portrait%20style&width=300&height=300&seq=customer4&orientation=squarish'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>お客様の声</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            岡山市・倉敷市でリフォーム工事をご依頼いただいたお客様から、たくさんの喜びの声をいただいています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-5 sm:p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center mb-2">
                    <h4 className="font-semibold text-gray-900 mr-2 text-sm sm:text-base">{testimonial.name}</h4>
                    <span className="text-xs sm:text-sm text-gray-500">({testimonial.location})</span>
                  </div>
                  <p className="text-xs sm:text-sm text-teal-600 font-medium mb-2">{testimonial.project}</p>
                  <div className="flex items-center mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm sm:text-base"></i>
                    ))}
                  </div>
                  <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">{testimonial.comment}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
